export default __webpack_public_path__ + "static/media/absolute-6.7c45151c.png";